// @flow
import React, { Component } from "react";
import classNames from "classnames";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";

import { InputStyles } from "./StyledTextField";
import type { StyledTextFieldClassesType } from "./StyledTextField";
import type { DictionaryType } from "../../types/GeneralTypes";

export const selectStyles = (theme: DictionaryType): DictionaryType => ({
  ...InputStyles(theme)
});

export type StyledSelectClassesType = {
  ...StyledTextFieldClassesType
};

type StyledSelectPropsType = {
  classes: StyledSelectClassesType,
  menus: Array<{ [key: string]: string }>,
  isInvalid?: boolean,
  label: string,
  name: string,
  isRequired?: boolean,
  value: string,
  onChange: Function,
  isMultiple?: boolean,
  helper?: string,
  isStyled?: boolean,
  isDisabled?: boolean
};

class StyledSelect extends Component<StyledSelectPropsType, *> {
  constructor(props: StyledSelectPropsType) {
    super(props);
  }

  render(): * {
    const classes = this.props.classes;
    const menus =
      this.props.menus &&
      this.props.menus.map(
        (menu: DictionaryType, i: number): React$Element<*> => {
          return (
            <MenuItem
              key={"menu-" + i}
              value={menu.value}
              style={{
                fontWeight: this.props.value === menu.value ? 600 : 400
              }}
            >
              {menu.label}
            </MenuItem>
          );
        }
      );
    return (
      <FormControl
        fullWidth={true}
        error={this.props.isInvalid}
        disabled={this.props.isDisabled}
      >
        {this.props.label !== "" && (
          <InputLabel
            htmlFor={this.props.name}
            required={this.props.isRequired}
            error={this.props.isInvalid}
            shrink={true}
            classes={{
              root: classes.greenLabel,
              formControl: this.props.isStyled
                ? classes.textFieldFormLabel
                : classes.labelFormControl,
              focused: classes.labelFocused,
              error: classes.labelError,
              disabled: classes.labelDisabled
            }}
          >
            {this.props.label}
          </InputLabel>
        )}
        <Select
          value={this.props.value}
          error={this.props.isInvalid}
          onChange={this.props.onChange}
          input={
            <Input
              name={this.props.name}
              id={this.props.name}
              disableUnderline={this.props.isStyled ? true : false}
              classes={{
                root: this.props.isStyled
                  ? classes.textFieldRoot
                  : classes.inputRootGreen,
                input: classNames({
                  [classes.textFieldInput]: this.props.isStyled,
                  [classes.inputFont]: !this.props.isStyled,
                  [classes.borderError]: this.props.isInvalid
                }),
                underline: classes.underlineGreen,
                error: classes.inputError,
                disabled: classes.inputDisabled
              }}
              readOnly={this.props.isDisabled}
            />
          }
          inputProps={{
            required: this.props.isRequired
          }}
          multiple={this.props.isMultiple}
        >
          {menus}
        </Select>
        {this.props.helper && (
          <FormHelperText
            error={this.props.isInvalid}
            classes={{ root: classes.helperText }}
          >
            {this.props.helper}
          </FormHelperText>
        )}
      </FormControl>
    );
  }
}

export default withStyles(selectStyles)(StyledSelect);
